import styled from 'styled-components';

export const Container = styled.div``;

export const Header = styled.header`
  padding: 32px 0;
  background: #f8f8f8;
  border-bottom: 1px solid #ddd;
`;

export const HeaderContent = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > button {
    background: transparent;
    border: 0;

    svg {
      color: ${(props) => props.theme.colors.primary};
      width: 24px;
      height: 24px;
      transition: color 0.2s;
    }

    &:hover {
      svg {
        color: ${(props) => props.theme.colors.error};
      }
    }
  }
`;

export const Profile = styled.div`
  display: flex;
  align-items: center;

  div {
    display: flex;
    flex-direction: column;
    line-height: 1.5;

    span {
      color: ${(props) => props.theme.colors.text_light};
    }

    strong {
      color: ${(props) => props.theme.colors.text};
      font-size: 1.2rem;
    }
  }
`;

// --- NOVOS ESTILOS ADICIONADOS AQUI ---

export const Content = styled.main`
  max-width: 1120px;
  margin: 64px auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  min-height: 85dvh;
  h2 {
    font-size: 1.5rem;
    margin-bottom: 24px;
    color: ${(props) => props.theme.colors.text};
  }

  /* Estilo para o link não ter a decoração padrão */
  a {
    text-decoration: none;
  }
`;

export const Card = styled.div`
  background: ${(props) => props.theme.colors.card_background};
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px; /* Espaçamento entre os elementos internos */

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }

  svg {
    color: ${(props) => props.theme.colors.primary};
  }

  strong {
    font-size: 1.25rem;
    color: ${(props) => props.theme.colors.text};
  }

  p {
    color: ${(props) => props.theme.colors.text_light};
    line-height: 1.6;
  }
`;
